{
  "VALIDATION_FAILED": "Review the highlighted fields and correct the entered values.",
  "UNAUTHENTICATED": "Sign in to continue.",
  "INVALID_CREDENTIALS": "The username or password is incorrect. Try again.",
  "ACCOUNT_LOCKED": "The account is temporarily locked due to too many attempts. Try again in 15 minutes.",
  "ACCOUNT_INACTIVE": "Account is inactive, contact your administrator",
  "ACCOUNT_PENDING": "This account has not completed setup yet. Contact your administrator for a new setup link.",
  "UNKNOWN_CARD": "Unknown card",
  "TOKEN_EXPIRED": "Your session expired",
  "TOKEN_REVOKED": "This session was revoked",
  "FORBIDDEN": "You do not have permission for this action",
  "NOT_FOUND": "The requested item was not found",
  "CONFLICT": "Conflicting data",
  "UNIQUE_VIOLATION": "This value is already taken",
  "FOREIGN_KEY_VIOLATION": "This record is connected to other records. Review those connections before changing it.",
  "RATE_LIMITED": "Too many attempts, try again later",
  "IDEMPOTENCY_KEY_REUSED": "This request was already used with different details. Open a new form to submit the changed details.",
  "REQUEST_IN_PROGRESS": "An earlier request is still being completed. Wait briefly before trying again.",
  "PAYLOAD_TOO_LARGE": "The submitted data is too large. Reduce it and try again.",
  "UNPROCESSABLE": "The action could not be completed. Review the entered details and try again.",
  "INTERNAL_ERROR": "The action could not be completed. Try again, or share the reference with your administrator.",
  "SERVICE_UNAVAILABLE": "The service is temporarily unavailable. Try again shortly.",
  "network": "Could not reach the server. Check your connection and try again.",
  "timeout": "We could not confirm this finished. Check the current state before trying again.",
  "referenceId": "Reference: {{requestId}}",
  "SSO_UNAVAILABLE": "Sign-in is temporarily unavailable. Try again shortly.",
  "SSO_SESSION_REVOKED": "Your session has ended. Sign in again.",
  "SSO_IDENTITY_INACTIVE": "This account is unavailable. Contact your administrator.",
  "SSO_BRANCH_INACTIVE": "This branch is unavailable. Choose another authorized branch.",
  "SSO_APPLICATION_INACTIVE": "This application is unavailable. Contact your administrator.",
  "REAUTHENTICATION_REQUIRED": "Sign in again to confirm your identity before continuing.",
  "RECOVERY_INVALID": "This link is expired or has already been used. Request a new link.",
  "RECOVERY_UNAVAILABLE": "This recovery method is unavailable. Contact an authorized administrator.",
  "PASSWORD_REJECTED": "Choose a different password that meets the password requirements.",
  "LAST_ADMINISTRATOR": "Keep at least one active platform administrator before making this change.",
  "PERMISSION_DEPENDENCY": "A selected permission depends on another permission. Review the required permissions.",
  "NO_BRANCH_ACCESS": "You do not have access to any branch. Contact your administrator.",
  "BRANCH_NOT_ALLOWED": "You are not allowed to work in this branch. Choose another branch.",
  "NO_PLATFORM_ACCESS": "You do not have access to this platform in the selected branch.",
  "LAUNCH_FAILED": "The system could not be opened. Sign in again.",
  "PLATFORM_NOT_ALLOWED": "You do not have access to this platform.",
  "PLATFORM_UNAUTHORIZED": "The platform could not be verified. Contact your administrator.",
  "INVALID_LAUNCH_CODE": "This launch link is invalid or expired. Open the platform again from the launcher.",
  "PASSWORD_TOKEN_INVALID": "This password link is invalid or has expired. Request a new link.",
  "USERNAME_TAKEN": "This username is already in use.",
  "SESSION_EXPIRED": "Your session expired. Sign in again.",
  "SESSION_REVOKED": "Your session was ended. Sign in again."
}
